import { createUseStyles } from 'react-jss';
export const useMenuButtonStyles = createUseStyles(() => ({
    button: {
        border: 'none',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        padding: '0'
    }
}));
